import {
    Box, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination,
    TableRow, Accordion, AccordionSummary, AccordionDetails, Typography
} from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
// styles

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import {
    Controller,
    useForm
} from "react-hook-form";
import { default as Apiservices } from '../../../common';
import DateRangePicker from "../../../components/DateRangePicker";
import useStyles from "../../../themes/makeStyles";
import FilterForm from "./filterForm";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";


const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {

    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };



    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                        <KeyboardArrowLeft />
                    )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                        <KeyboardArrowRight />
                    )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
    table: {
        minWidth: "100%",
        whiteSpace: "nowrap",
        td: {

        }
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        maxHeight: "60vh",
        minHeight: "100px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export default function JobDetailsReport(props) {
    const classesTwo = useStyles();
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);
    const [loading, setLoading] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [resetvalues, setResetvalues] = React.useState(true);
    const [saveFilterData, setSaveFilterData] = React.useState();
    const [sftorrEndDate, setSftorrEndDate] = React.useState();
    const [disableSftoButton, setDisableSftoButton] = React.useState(true);
    const [showFilterFlag, setShowFilterFlag] = useState(false);
    const [expandedPanel, setExpandedPanel] = useState({
        panel1: true,
        panel2: true
    });

    var tableData = [{
        destination: "No Data",
        ir_load_name: "No Data",
        ir_rake_id: "No Data",
        rr_actual_weight: "No Data",
        rr_amount: "No Data",
        rr_chargeable_weight: "No Data",
        rr_date: "No Data",
        rr_no: "No Data",
        rr_punitive: "No Data"
    }]

    const fetchData = async (data) => {
        let response;
        if (data) {
            response = await Apiservices.getSftoJobDeatilsReport(data);
        } else {
            response = await Apiservices.getSftoJobDeatilsReport();
        }
        if (response && response.Records.length > 0) {
            setArray(response.Records && response.Records.length > 0 ? response.Records : []);
        } else {
            setArray([]);
            console.log("Server not working")
        }
        console.log(response, "apiresp")
    }

    const methods = useForm({
        mode: "onChange",
        validateCriteriaMode: "all",
        // defaultValues: getHeaderInfoDefaultData(modeOfDispatch),
    });

    const handleAccordionChange = (panel, expandedPanel) => (
        event,
        isExpanded
    ) => {
        let expansionPanelList = {};
        expansionPanelList = expandedPanel;

        expansionPanelList[panel] = expansionPanelList[panel] ? false : true;
        setExpandedPanel({
            panel1:
                panel === "panel1"
                    ? expansionPanelList[panel]
                    : expansionPanelList["panel1"],
            panel2:
                panel === "panel2"
                    ? expansionPanelList[panel]
                    : expansionPanelList["panel2"],
        });
    };

    const {
        register,
        control,
        errors,
        handleSubmit,
        setValue,
        reset,
        getValues,
    } = methods;

    useEffect(() => {
        const response = fetchData();
    }, []);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        let params = {}
        params.limit = newPage - 1
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getSplInstructions = (instructions) => {
        let value = '';
        let spitOfInstructions = instructions.split(" ");
        for (let i = 0; spitOfInstructions.length; i++) {
            if (spitOfInstructions[i] === 'Load' || spitOfInstructions[i] === 'LOAD' || spitOfInstructions[i] === 'load') {
                value = value + ' ' + spitOfInstructions[i];
                return value;
            } else {
                value = value + ' ' + spitOfInstructions[i];
            }
        }
        return value;
    }

    const getRakeIdFromName = (rakeId) => {
        let splitRakeId = rakeId.split("/");
        return splitRakeId[0];
    }


    const handleSearchCriteriaSubmit = async (submitteddata) => {
        let queryparams = {};
        let rr_start_end_dates = submitteddata.rr_start_end_date
            ? submitteddata.rr_start_end_date.split("To")
            : null;
        queryparams.rr_start_date = rr_start_end_dates
            ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
            : null;
        queryparams.rr_end_date = rr_start_end_dates
            ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
            : null;
        setLoading(true);
        let response = await Apiservices.getSftoJobDeatilsReport(queryparams);
        if (response && response.Records.length > 0) {
            setArray(response.Records && response.Records.length > 0 ? response.Records[0] : []);
            setDisableSftoButton(false);
        } else {
            setArray([]);
            console.log("Server not working")
        }
        setLoading(false);
    };


    const getFilterData = (values) => {
        // setSaveSearchTerm(null)
        setSaveFilterData(values)
        fetchData(values)
        // setCheckedList([]);
    }

    const handleClear = () => {
        // setSaveSearchTerm(null)
        setSaveFilterData(null)
        fetchData();
    }

    const resetForm = async () => {
        setResetvalues(!resetvalues);
        setDisableSftoButton(true);
        let obj = {
            rr_start_date: '2009-01-01',
            rr_end_date: '2070-01-01'
        }
        setLoading(true);
        let response = await Apiservices.getSftoJobDeatilsReport(obj);
        setArray(response.Records && response.Records.length > 0 ? response.Records[0] : []);
        setLoading(false);
    };



    return (
        <>
            <div>
                <Box py={3}>
                    <Grid container spacing={2} justify="space-between" alignItems="center">
                        <Grid item>
                            <h2 className={classesTwo.mainHeading}>{"SFTO - Job Details Report"}</h2>
                        </Grid>
                    </Grid>
                </Box>



                <Box py={1}>
                    <form
                        // onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
                        id="list-job"
                        key={resetvalues}
                    >
                        {showFilterFlag ? (
                            <div />
                        ) : (
                                <Box py={1}>
                                    <Paper elevation={0}>
                                        <Accordion
                                            expanded={expandedPanel["panel1"] === true}
                                            onChange={handleAccordionChange("panel1", expandedPanel)}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography className={classes.secondHeading}>
                                                    Filter By
                                    </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Box width={'100%'}>
                                                    <FilterForm getFilterData={getFilterData} handleClear={handleClear} />
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Paper>
                                </Box>
                            )}
                    </form>
                </Box>

                <div>
                    {array.length > 0 ? (
                        <Box py={1}>
                            <TableContainer component={Paper} className={clsx('freezeTable', classes.container)}>
                                <Table
                                    // className={clsx('freezeTable')}
                                    aria-label="simple table"
                                    stickyHeader
                                >
                                    {loading ? (
                                        <></>
                                    ) : (
                                            <>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="left" >
                                                            <b>Job ID </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center"  >
                                                            <b>Customer Name</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Name</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Cost Center</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Customer Ref. No.</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Season Type</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Work Order No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Threshold Type </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Threshold Period Start Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Threshold Period End Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Remaining Threshold Amount</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Origin</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Origin Code</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Destination</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Destination Code</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Return Station</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Distance To Be Covered</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Additional Distance Covered</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Additional Freight Charged By IR</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Is Debit Note Generated</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Type</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>No Of Wagons Attached To Rake</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Status</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Id</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>No Of Wagons To Be Loaded</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Plant Arrival Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Next ROH Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Next POH Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Expected Date Of Departure</b>
                                                        </StyledTableCell>

                                                        <StyledTableCell align="center">
                                                            <b>Chargeable Weight</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Cargo Readiness Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Is Approved</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Reason For Rejection</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Credit Limit Crossed</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Is Proforma Invoice Confirmed</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Advance Requistion Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Advance Requistion Amount</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Special Instructions</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Route Id</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Approved By</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Approved Remarks</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Approved Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Job Approval Status</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Is Credit Check Done</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP IO ID</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP SO ID</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP SO Invoice ID</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP Proforma ID</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP Lineitem No </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Serv Mat No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Serv Mat Desc</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Target Qty UOM</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Target Qty</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Unit Price</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Ship To Party</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Customer Ref Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP Customer Id</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Cust Grp5</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP Rake Number</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Purchase Contract No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Purchase Lineitem No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Vendor Code</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SAP Ship To Party</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Total Fee </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Invoice Created Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SO Created Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Total Fees Value</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Remaining Threshold Quantity</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Payment Terms</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Service Type</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SO Group</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>SO Number</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Invoice Number</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Invoice Generated</b>
                                                        </StyledTableCell>

                                                        <StyledTableCell align="center">
                                                            <b>Job Created User EmailID</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Po Vendor </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Po Vendor Id</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Map My India Id </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Is Full Load Or Part Load</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Placement Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Insp At Destination Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Cargo Same As Packing List</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Unloading Start Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Unloading End Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Confirm Final Invoice</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Departure Readiness Date Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Destination Memo Creation Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Loco Allotment Date Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Loco No </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Engine On Train Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Return Departure Date Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Return Drawout Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Return Gps Device Id</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Estimated Return Date Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Estimated Return Time Per Division</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Return Distance In Kms </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Return Arrival Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Tat</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>  Gps Device Id </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Last Station Crossed </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>   Last Station Crossed Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>   Current Division</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Final Transit Status </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>   Reason For Discrepancy </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Solution Adopted</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Enroute Wagon Detached </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Estimated Arrival Datetime At Destination</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Cleaning Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Cleaning Vendor Po No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Is Wagon Damaged</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Is Invoice Confirmed </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Destination Memo Attachment </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Actual Arrival At Destination Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Wagon No Attached With Gps </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Reason For Delay </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Damage To Wagon</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Invoice Remarks </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Load No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Destination Memo Attachment Dms Fileid</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Invoice Bill Date </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>No Of Kms Travelled By Rake </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Estd Tat </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Total Lease Rental </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Location</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Eta At Destination </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Expected Time Per Division</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Updatedy</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Indent No </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Indent Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Railways Insp Strt Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Is Ok </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Placement Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Loading Start Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Railways Insp End Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Arrival At Yard Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Examination Report Attachment</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Offered To Customer By Tmill Or Railways</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Made Over Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Arrival At Plant Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Fund Availability</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> No Of Loading Points </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Post Loading Insp Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Offered To Railways Date Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Draw Out Date Time </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Wagon Attached To Gps </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Forwarding Note Attachment</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Route Type</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Route Intermediate Station Id </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Examination Report Attachment Dms Fileid </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Other Charge Name </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Other Charge Value </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Remarks</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rr Date</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Line Item </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Fees</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Threshold Remaining Amount Before</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Threshold Remaining Amount After</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Quantity</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Threshold Remaining Quantity Before</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Threshold Remaining Quantity After</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Total Wagon Tare </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Total Carrying Capacity </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>  Total No Of Packages</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>  Total Cargo Weight </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Total Gross Weight</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Packing List Attachment </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Estimated Rr Amount </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Estimated Rebate Amount</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Estimated Additional Rebate Percentage</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Estimated Additional Rebate Amount</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Railways Receipt Attachment </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rr No </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rr Punitive</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rr Amount </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rebate Amount </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Stabling Charges</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Ir Rake Id</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Ir Load Name</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Train Ordering Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Eot Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Origin Load Name </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rake Departure Date Time</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Wagon No Attached To Gps </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Destination Type </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Basic Freight</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rr Chargeable Weight</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Forward Note Attachment </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Packing List Attachment Dms Fileid </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Railways Receipt Attachment Dms Fileid </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Forward Note Attachment Dms Fileid </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Rr Actual Weight </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Tax Invoice No</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Return Distance</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Is Full Or Part Load </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b>Estimate Return Time Per Division</b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Loco Allotment Datetime </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Eot Datetime </b>
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <b> Rake Departure Datetime </b>
                                                        </StyledTableCell>


                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {(array && rowsPerPage > 0
                                                        ? array?.slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        : array
                                                    ).map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center" style={{ minWidth: 200, maxWidth: 200 }}>
                                                                {
                                                                    row.job_id ? (
                                                                        <b>{row.job_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">

                                                                {
                                                                    row.customer_name ? (
                                                                        <b>{row.customer_name}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }

                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_name ? (
                                                                        <b>{row.rake_name}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.cost_center ? (
                                                                        <b>{row.cost_center}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.customer_ref ? (
                                                                        <b>{row.customer_ref}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.season_type ? (
                                                                        <b>{row.season_type}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_type ? (
                                                                        <b>{row.threshold_type}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.work_order_no ? (
                                                                        <b>{row.work_order_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_period_start_date ? (
                                                                        <b>{row.threshold_period_start_date}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_period_end_date ? (
                                                                        <b>{row.threshold_period_end_date}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.remaining_threshold_amount ? (
                                                                        <b>{row.remaining_threshold_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.origin ? (
                                                                        <b>{row.origin}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.origin_code ? (
                                                                        <b>{row.origin_code}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.destination ? (
                                                                        <b>{row.destination}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.destination_code ? (
                                                                        <b>{row.destination_code}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.return_station ? (
                                                                        <b>{row.return_station}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.distance_to_be_covered ? (
                                                                        <b>{row.distance_to_be_covered}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.additional_distance_covered ? (
                                                                        <b>{row.additional_distance_covered}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.additional_freight_charged_by_ir ? (
                                                                        <b>{row.additional_freight_charged_by_ir}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.is_debit_note_generated ? (
                                                                        <b>{row.is_debit_note_generated}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_type ? (
                                                                        <b>{row.rake_type}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.no_of_wagons_attached_to_rake ? (
                                                                        <b>{row.no_of_wagons_attached_to_rake}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_status ? (
                                                                        <b>{row.rake_status}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_id ? (
                                                                        <b>{row.rake_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.no_of_wagons_to_be_loaded ? (
                                                                        <b>{row.no_of_wagons_to_be_loaded}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.plant_arrival_date ? (
                                                                        <b>{moment(row.plant_arrival_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.next_roh_date ? (
                                                                        <b>{moment(row.next_roh_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.next_poh_date ? (
                                                                        <b>{moment(row.next_poh_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.expected_date_of_departure ? (
                                                                        <b>{moment(row.expected_date_of_departure).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.chargeable_weight ? (
                                                                        <b>{row.chargeable_weight}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.cargo_readiness_date ? (
                                                                        <b>{moment(row.cargo_readiness_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.is_approved ? (
                                                                        <b>{row.is_approved}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.reason_for_rejection ? (
                                                                        <b>{row.reason_for_rejection}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.credit_limit_crossed ? (
                                                                        <b>{row.credit_limit_crossed}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.is_proforma_invoice_confirmed ? (
                                                                        <b>{row.is_proforma_invoice_confirmed}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.advance_requistion_date ? (
                                                                        <b>{moment(row.advance_requistion_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.advance_requistion_amount ? (
                                                                        <b>{row.advance_requistion_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.special_instructions ? (
                                                                        <b>{row.special_instructions}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.route_id ? (
                                                                        <b>{row.route_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.approved_by ? (
                                                                        <b>{row.approved_by}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.approver_remarks ? (
                                                                        <b>{row.approver_remarks}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.approved_date ? (
                                                                        <b>{moment(row.approved_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.job_approval_status ? (
                                                                        <b>{row.job_approval_status}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.is_credit_check_done ? (
                                                                        <b>{row.is_credit_check_done}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_io_id ? (
                                                                        <b>{row.sap_io_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_so_id ? (
                                                                        <b>{row.sap_so_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_so_invoice_id ? (
                                                                        <b>{row.sap_so_invoice_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_proforma_id ? (
                                                                        <b>{row.sap_proforma_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_lineitem_no ? (
                                                                        <b>{row.sap_lineitem_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.serv_mat_no ? (
                                                                        <b>{row.serv_mat_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.serv_mat_desc ? (
                                                                        <b>{row.serv_mat_desc}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.target_qty_uom ? (
                                                                        <b>{row.target_qty_uom}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.target_qty ? (
                                                                        <b>{row.target_qty}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.unit_price ? (
                                                                        <b>{row.unit_price}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_ship_to_party ? (
                                                                        <b>{row.sap_ship_to_party}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.customer_ref_date ? (
                                                                        <b>{moment(row.customer_ref_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_customer_id ? (
                                                                        <b>{row.sap_customer_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.CUST_GRP5 ? (
                                                                        <b>{row.CUST_GRP5}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_rake_number ? (
                                                                        <b>{row.sap_rake_number}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.purchase_contract_no ? (
                                                                        <b>{row.purchase_contract_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.purchase_lineitem_no ? (
                                                                        <b>{row.purchase_lineitem_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.vendor_code ? (
                                                                        <b>{row.vendor_code}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.sap_ship_to_party ? (
                                                                        <b>{row.sap_ship_to_party}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_fee ? (
                                                                        <b>{row.total_fee}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.invoice_created_date ? (
                                                                        <b>{moment(row.invoice_created_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.so_created_date ? (
                                                                        <b>{moment(row.so_created_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_fees_value ? (
                                                                        <b>{row.total_fees_value}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.remaining_threshold_quantity ? (
                                                                        <b>{row.remaining_threshold_quantity}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.payment_terms ? (
                                                                        <b>{row.payment_terms}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.service_type ? (
                                                                        <b>{row.service_type}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.so_group ? (
                                                                        <b>{row.so_group}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.so_number ? (
                                                                        <b>{row.so_number}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.invocie_number ? (
                                                                        <b>{row.invocie_number}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.invocie_generated ? (
                                                                        <b>{row.invocie_generated}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.job_created_user_emailid ? (
                                                                        <b>{row.job_created_user_emailid}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.po_vendor ? (
                                                                        <b>{row.po_vendor}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.po_vendor_id ? (
                                                                        <b>{row.po_vendor_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.map_my_india_id ? (
                                                                        <b>{row.map_my_india_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_is_full_load_or_part_load ? (
                                                                        <b>{row.rake_is_full_load_or_part_load}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_placement_date_time ? (
                                                                        <b>{moment(row.rake_placement_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_insp_at_destination_date_time ? (
                                                                        <b>{moment(row.rake_insp_at_destination_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.cargo_same_as_packing_list ? (
                                                                        <b>{row.cargo_same_as_packing_list}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.unloading_start_date_time ? (
                                                                        <b>{moment(row.unloading_start_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.unloading_end_date_time ? (
                                                                        <b>{moment(row.unloading_end_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.confirm_final_invoice ? (
                                                                        <b>{row.confirm_final_invoice}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.departure_readiness_date_time ? (
                                                                        <b>{moment(row.departure_readiness_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.destination_memo_creation_date_time ? (
                                                                        <b>{moment(row.destination_memo_creation_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.loco_allotment_datetime ? (
                                                                        <b>{moment(row.loco_allotment_datetime).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.loco_no ? (
                                                                        <b>{row.loco_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.engine_on_train_date_time ? (
                                                                        <b>{moment(row.engine_on_train_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.return_departure_date_time ? (
                                                                        <b>{moment(row.return_departure_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.return_drawout_date_time ? (
                                                                        <b>{moment(row.return_drawout_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.return_gps_device_id ? (
                                                                        <b>{row.return_gps_device_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.estimated_return_date_time ? (
                                                                        <b>{moment(row.estimated_return_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.estimated_return_time_per_division ? (
                                                                        <b>{moment(row.estimated_return_time_per_division).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.return_distance_in_kms ? (
                                                                        <b>{row.return_distance_in_kms}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.return_arrival_date_time ? (
                                                                        <b>{moment(row.return_arrival_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.tat ? (
                                                                        <b>{row.tat}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.gps_device_id ? (
                                                                        <b>{row.gps_device_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.last_station_crossed ? (
                                                                        <b>{row.last_station_crossed}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.last_station_crossed_time ? (
                                                                        <b>{moment(row.last_station_crossed_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.current_division ? (
                                                                        <b>{row.current_division}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.final_transit_status ? (
                                                                        <b>{row.final_transit_status}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.reason_for_discrepancy ? (
                                                                        <b>{row.reason_for_discrepancy}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.solution_adopted ? (
                                                                        <b>{row.solution_adopted}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.enroute_wagon_detached ? (
                                                                        <b>{row.enroute_wagon_detached}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.estimated_arrival_datetime_at_destination ? (
                                                                        <b>{moment(row.estimated_arrival_datetime_at_destination).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_cleaning_date_time ? (
                                                                        <b>{moment(row.rake_cleaning_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.cleaning_vendor_po_no ? (
                                                                        <b>{row.cleaning_vendor_po_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.is_wagon_damaged ? (
                                                                        <b>{row.is_wagon_damaged}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.is_invoice_confirmed ? (
                                                                        <b>{row.is_invoice_confirmed}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.destination_memo_attachment ? (
                                                                        <b>{row.destination_memo_attachment}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.actual_arrival_at_destination_date_time ? (
                                                                        <b>{moment(row.actual_arrival_at_destination_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.wagon_no_attached_with_gps ? (
                                                                        <b>{row.wagon_no_attached_with_gps}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.reason_for_delay ? (
                                                                        <b>{row.reason_for_delay}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.damage_to_wagon ? (
                                                                        <b>{row.damage_to_wagon}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.invoice_remarks ? (
                                                                        <b>{row.invoice_remarks}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.load_no ? (
                                                                        <b>{row.load_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.destination_memo_attachment_dms_fileid ? (
                                                                        <b>{row.destination_memo_attachment_dms_fileid}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.invoice_bill_date ? (
                                                                        <b>{moment(row.invoice_bill_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.no_of_kms_travelled_by_rake ? (
                                                                        <b>{row.no_of_kms_travelled_by_rake}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.estd_tat ? (
                                                                        <b>{row.estd_tat}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_lease_rental ? (
                                                                        <b>{row.total_lease_rental}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_location ? (
                                                                        <b>{row.rake_location}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.eta_at_destination ? (
                                                                        <b>{moment(row.eta_at_destination).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.expected_time_per_division ? (
                                                                        <b>{row.expected_time_per_division}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.updatedy ? (
                                                                        <b>{row.updatedy}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.indent_no ? (
                                                                        <b>{row.indent_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.indent_date ? (
                                                                        <b>{moment(row.indent_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.railways_insp_strt_time ? (
                                                                        <b>{moment(row.railways_insp_strt_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_is_ok ? (
                                                                        <b>{row.rake_is_ok}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_placement_time ? (
                                                                        <b>{moment(row.rake_placement_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.loading_start_time ? (
                                                                        <b>{moment(row.loading_start_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.railways_insp_end_time ? (
                                                                        <b>{moment(row.railways_insp_end_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_arrival_at_yard_date_time ? (
                                                                        <b>{moment(row.rake_arrival_at_yard_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_examination_report_attachment ? (
                                                                        <b>{row.rake_examination_report_attachment}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.offered_to_customer_by_tmill_or_railways ? (
                                                                        <b>{moment(row.offered_to_customer_by_tmill_or_railways).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.made_over_date_time ? (
                                                                        <b>{moment(row.made_over_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.arrival_at_plant_date_time ? (
                                                                        <b>{moment(row.arrival_at_plant_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                {
                                                                    row.fund_availability ? (
                                                                        <b>{row.fund_availability}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.no_of_loading_points ? (
                                                                        <b>{row.no_of_loading_points}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.post_loading_insp_date_time ? (
                                                                        <b>{moment(row.post_loading_insp_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.offered_to_railways_date_time ? (
                                                                        <b>{moment(row.offered_to_railways_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.draw_out_date_time ? (
                                                                        <b>{moment(row.draw_out_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.wagon_attached_to_gps ? (
                                                                        <b>{row.wagon_attached_to_gps}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.forwarding_note_attachment ? (
                                                                        <b>{row.forwarding_note_attachment}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.route_type ? (
                                                                        <b>{row.route_type}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.route_intermediate_station_id ? (
                                                                        <b>{row.route_intermediate_station_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_examination_report_attachment_dms_fileid ? (
                                                                        <b>{row.rake_examination_report_attachment_dms_fileid}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.other_charge_name ? (
                                                                        <b>{row.other_charge_name}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.other_charge_value ? (
                                                                        <b>{row.other_charge_value}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.remarks ? (
                                                                        <b>{row.remarks}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rr_date ? (
                                                                        <b>{moment(row.rr_date).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.line_item ? (
                                                                        <b>{row.line_item}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.fees ? (
                                                                        <b>{row.fees}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_remaining_amount_before ? (
                                                                        <b>{row.threshold_remaining_amount_before}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_remaining_amount_after ? (
                                                                        <b>{row.threshold_remaining_amount_after}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.quantity ? (
                                                                        <b>{row.quantity}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_remaining_quantity_before ? (
                                                                        <b>{row.threshold_remaining_quantity_before}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.threshold_remaining_quantity_after ? (
                                                                        <b>{row.threshold_remaining_quantity_after}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_wagon_tare ? (
                                                                        <b>{row.total_wagon_tare}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_carrying_capacity ? (
                                                                        <b>{row.total_carrying_capacity}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_no_of_packages ? (
                                                                        <b>{row.total_no_of_packages}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_cargo_weight ? (
                                                                        <b>{row.total_cargo_weight}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.total_gross_weight ? (
                                                                        <b>{row.total_gross_weight}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.packing_list_attachment ? (
                                                                        <b>{row.packing_list_attachment}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.estimated_rr_amount ? (
                                                                        <b>{row.estimated_rr_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.estimated_rebate_amount ? (
                                                                        <b>{row.estimated_rebate_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.estimated_additional_rebate_percentage ? (
                                                                        <b>{row.estimated_additional_rebate_percentage}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.estimated_additional_rebate_amount ? (
                                                                        <b>{row.estimated_additional_rebate_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.railways_receipt_attachment ? (
                                                                        <b>{row.railways_receipt_attachment}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rr_no ? (
                                                                        <b>{row.rr_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rr_punitive ? (
                                                                        <b>{row.rr_punitive}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rr_amount ? (
                                                                        <b>{row.rr_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rebate_amount ? (
                                                                        <b>{row.rebate_amount}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.stabling_charges ? (
                                                                        <b>{row.stabling_charges}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.ir_rake_id ? (
                                                                        <b>{row.ir_rake_id}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.ir_load_name ? (
                                                                        <b>{row.ir_load_name}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.train_ordering_date_time ? (
                                                                        <b>{row.train_ordering_date_time}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.eot_date_time ? (
                                                                        <b>{moment(row.eot_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.origin_load_name ? (
                                                                        <b>{row.origin_load_name}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_departure_date_time ? (
                                                                        <b>{moment(row.rake_departure_date_time).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.wagon_no_attached_to_gps ? (
                                                                        <b>{row.wagon_no_attached_to_gps}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.destination_type ? (
                                                                        <b>{row.destination_type}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.basic_freight ? (
                                                                        <b>{row.basic_freight}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rr_chargeable_weight ? (
                                                                        <b>{row.rr_chargeable_weight}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.forward_note_attachment ? (
                                                                        <b>{row.forward_note_attachment}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.packing_list_attachment_dms_fileid ? (
                                                                        <b>{row.packing_list_attachment_dms_fileid}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.railways_receipt_attachment_dms_fileid ? (
                                                                        <b>{row.railways_receipt_attachment_dms_fileid}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.forward_note_attachment_dms_fileid ? (
                                                                        <b>{row.forward_note_attachment_dms_fileid}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rr_actual_weight ? (
                                                                        <b>{row.rr_actual_weight}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.tax_invoice_no ? (
                                                                        <b>{row.tax_invoice_no}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.return_distance ? (
                                                                        <b>{row.return_distance}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.rake_is_full_or_part_load ? (
                                                                        <b>{row.rake_is_full_or_part_load}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.estimate_return_time_per_division ? (
                                                                        <b>{moment(row.estimate_return_time_per_division).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.loco_allotment_datetime ? (
                                                                        <b>{moment(row.loco_allotment_datetime).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.eot_datetime ? (
                                                                        <b>{moment(row.eot_datetime).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {
                                                                    row.rake_departure_datetime ? (
                                                                        <b>{moment(row.rake_departure_datetime).format('DD-MM-YYYY')}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {
                                                                    row.damage_wagon_details ? (
                                                                        <b>{row.damage_wagon_details}</b>
                                                                    ) : (
                                                                            <b>-</b>
                                                                        )
                                                                }
                                                            </TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>

                                                <TableFooter>
                                                    <TableRow></TableRow>
                                                </TableFooter>
                                            </>
                                        )}
                                </Table>
                            </TableContainer>
                            <TableContainer>
                                <TablePagination
                                    className={classes.toobarBgColor}
                                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                    component="div"
                                    count={array && array.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: { "aria-label": "rows per page" },
                                        native: true,
                                    }}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableContainer>
                        </Box>
                    ) : <Box py={1}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Grid item xs={12} sm>
                                    <Box my={1}>
                                        <h3 classname={classes.secondHeading}>No Records Found</h3>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    }
                </div >
            </div>
        </>
    );
}